import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map, Observable, of } from 'rxjs';
import {
  loadUser,
  requestSuccess,
  requestError,
  changeStatusUser,
} from './client-user.action';
import { Action } from '@ngrx/store';
import { AdminUserService } from '../../../admin/dashboard/services/admin-user.services';
import { ResponseUserInterface } from '../../../admin/dashboard/interfaces/user.inferfaces';
import { ErrorInterface } from '../../../@core/interfaces/general.interface';

@Injectable()
export class ClientUserEffect {
  constructor(private service: AdminUserService, private actions$: Actions) {}

  public getUser$ = createEffect((): Observable<Action> => {
    return this.actions$.pipe(
      ofType(loadUser),
      exhaustMap((payload: { id: number }) => {
        return this.service.getAdminUser(payload.id).pipe(
          map((response: ResponseUserInterface) => {
            if (response.errorCode.code !== 0) {
              throw response.errorCode;
            }
            return requestSuccess({ response });
          }),
          catchError((error: ErrorInterface) => of(requestError({ error })))
        );
      })
    );
  });

  public changeStatusUser$ = createEffect((): Observable<Action> => {
    return this.actions$.pipe(
      ofType(changeStatusUser),
      exhaustMap((payload: { id: number; status: string }) => {
        return this.service
          .changeStatusAdminUser(payload.id, payload.status)
          .pipe(
            map((response: ResponseUserInterface) => {
              if (response.errorCode.code !== 0) {
                throw response.errorCode;
              }
              return requestSuccess({ response });
            }),
            catchError((error: ErrorInterface) => of(requestError({ error })))
          );
      })
    );
  });
}
